import { render, staticRenderFns } from "./ModalOdonto.vue?vue&type=template&id=70eabcf9&scoped=true&"
import script from "./ModalOdonto.vue?vue&type=script&lang=ts&"
export * from "./ModalOdonto.vue?vue&type=script&lang=ts&"
import style0 from "./ModalOdonto.vue?vue&type=style&index=0&id=70eabcf9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70eabcf9",
  null
  
)

export default component.exports